const es = {
  translation: {
    dashboard: 'Dashboard',
    de: 'de',

    no_tipo_recurso: 'No hay recursos de este tipo descargado',
    no_tipo_agrupacion: 'No hay agrupaciones de este tipo descargadas',

    OBJECT_TYPE_Recurso: 'Recurso',
    OBJECT_TYPE_Agrupacion: 'Agrupación',

    cantidad_recursos: 'Recursos en esta colección',

    //info del rankin
    posicion: 'Posición',
    titulo: 'Título',

    //footer
    contacto: 'Contacto',
    linea_nacional:
      'Línea nacional: 01-8000- 51-0258, Línea en Bogotá: 4890400',
    horario_atencion:
      'Horario de Atención: Lunes a Viernes- 8:00 a.m. a 5:00 p.m',
    derechos_reservados: 'Reservados todos los derechos',

    Textual: 'Textos',
    Software: 'Software',
    Interactivo: 'Interactivo',
    Grafico: 'Imágenes',
    Sonoro: 'Audios',
    Audiovisual: 'Videos',
    Multimedia: 'Multimedia',

    calificacion: 'Calificación',
    catalogo: 'Catálogo',

    //Descripcion recurso
    comentario: 'Comentarios',
    no_comentarios: 'Este recurso no tiene comentarios',
    califica_recurso: 'Califica este recurso',
    agregar_favoritos: 'Agregar a favoritos',
    palabra_clave: 'Palabras clave',
    publico_objetivo: 'Público objetivo',
    tipo_contenido: 'Tipo de contenido',
    autores: 'Autores',
    licenciante: 'Licenciante',
    sugerencia_uso_pedagogico: 'Sugerencia de uso pedagógico',
    descripcion: 'Descripción',
    recursos_relacionados: 'Recursos relacionados',
    opciones: 'Ver opciones',
    ingresar_colombia_aprende:
      'Para agregar el recurso a Favoritos es necesario que ingrese con su cuenta del portal',
    colombia_aprende: 'Colombia Aprende',
    iniciar_sesion_registro: 'Iniciar sesión ó Registrarse',

    //Landing
    contenidos_destacados: 'Descubre nuestras colecciones destacadas',
    landing_mensaje:
      'El Ministerio de Educación Nacional de Colombia pone a disposición de las instituciones educativas, estudiantes, educadores/as y público en general, a través del Catálogo de Recursos Educativos Digitales (RED Aprende) un amplio número de recursos educativos digitales.',
    nuevos_recursos: 'Nuevos Recursos',
    recursos_colecciones_mas_vistas: 'Recursos y colecciones más vistas',

    //header
    header_agrupaciones: 'Agrupaciones',
    header_recursos: 'Recursos',

    //aside
    aside_descargas: 'Descargas',
    aside_ajustes: 'Ajustes',

    explorar: 'Explorar',

    agregacion: 'Colección',
    destilacion: 'Ranking',
    cronologia: 'Línea de tiempo',

    todas: 'Todas',
    tipo_agrupacion: 'Tipo de Agrupación',
    buscar_agrupacione_descargas: 'Buscar agrupaciones',

    landing_no_resultados:
      'Lo sentimos, no se encontraron resultados para la búsqueda!',
    selecciona: 'Selecciona',

    poblacion_objetivo: 'Población objetivo',
    nivel_educativo: 'Nivel educativo',
    nucleo_basico: 'Nucleo básico del conocimiento',
    compartir_facebook: 'Compartir en Facebook',
    compartir_twitter: 'Compartir en Twitter',
    compartir_whatsapp: 'Compartir en WhatsApp',
    tipo_licencia: 'Tipo de licencia',

    toast_guardado: 'Guardado exitosamente!',
    toast_descargado_prev: 'Recurso descargado previamente',
    toast_eliminado: 'Recurso eliminado exitosamente',
    toast_completar_accion: 'No se pudo completar la acción',
    toast_descarg_iniciada: 'Descarga en progreso',
    toast_descarga_finalizada: 'Descarga finalizada',
    toast_descarga_error: 'Ha ocurrido un error, por favor intenta de nuevo',

    panel_minimizar: 'Minimizar panel',
    panel_maximizar: 'Maximizar panel',

    dl_desc_recurso: 'Recurso',

    dl_element_borrar: 'Borrar recurso',
    dl_element_ver: 'Ver información',

    empty_para_descargar: 'Para descargar recursos dirigete al',
    empty_no_descargas: 'No has descargado recursos',

    empty_para_descarga_agrupaciones:
      'Para descargar agrupaciones dirigete al',
    empty_no_descargas_agrupaciones: 'No has descargado agrupaciones',

    header_cambiar_idioma: 'Cambiar idioma',

    landing_resultados_encontrados: 'Resultados por',
    landing_reiniciar_busqueda: 'Reiniciar búsqueda',
    landing_filtrar: 'Filtrar',
    landing_limpiar_filtros: 'Limpiar',
    landing_tipos_recurso: 'Tipos de recurso',
    landing_formatos: 'Formatos',
    landing_dificultad: 'Dificultad',
    landing_nivel_educativo: 'Nivel educativo',
    landing_area_conocimiento: 'Áreas de conocimiento',
    landing_filtros: 'Filtros',

    imagenes: 'Imagenes',
    videos: 'Videos',
    documentos: 'Documentos',
    audio: 'Audios',
    otros: 'Otros',
    todos: 'Todos',

    inicio: 'Inicio',
    descargas: 'Mis Descargas',
    buscar: 'Buscar',
    buscador: 'Busca por palabra clave',
    espanol: 'ES',
    ingles: 'EN',
    guardar_recurso: 'Guardar recurso',
    descargar_recurso: 'Descargar recurso',
    acerca: 'Acerca',
    licencia: 'Licencia',
    documentacion: 'Documentación',
    ver_nueva_pestana: ' Ver en nueva pestaña',
    compartir: 'Compartir',

    modal_eliminar_titulo: 'Borrar',
    modal_eliminar_mensaje: '¿Esta seguro de eliminar el recurso ',
    modal_eliminar_cancelar: 'Cancelar',
    modal_eliminar_borrar: 'BORRAR',

    buscar_descargas: 'Buscar descargas',
    borrar: 'Borrar',
    info: 'Informacion del recurso',
    recurso_descargado: 'Recurso descargado',
    descargar: 'Descargar',
    downloaded: 'Descargado',

    portugues: 'PT',

    header_colecciones: 'Colecciones',
    sin_colecciones_para_mostrar:
      'No hay colecciones para mostrar en la sección.',
    ir_a_coleccion: 'Ir a la colección',
    ver_comentarios: 'Ver comentarios',
    recursos_mejor_puntuados: 'Recursos mejor puntuados',
    visualizacion_no_disponible:
      'La visualización del recurso no se encuentra disponible',

    // Textos de Header.js
    header_site_title: 'RED Aprende',
    header_govco_title: 'GOV.CO',
    header_login: 'Iniciar Sesión',
    header_language: 'Idioma',
    header_favorites: 'Favoritos',
    header_loading: 'cargando...',
    header_spanish: 'Español',
    header_english: 'English',
    header_portuguese: 'Portugues',
    header_govco_nav_aria: 'Navegación Gov.co principal',
    header_login_aria: 'Iniciar sesión en la plataforma',
    header_spanish_aria: 'Seleccionar idioma español',
    header_english_aria: 'Select English language',
    header_portuguese_aria: 'Selecionar idioma português',
    header_main_nav_aria: 'Navegación principal del sitio',
    header_main_menu_aria: 'Menú principal de la aplicación',
    header_home_link_aria: 'Ir a la página de inicio',
    buscador_aria: 'Campo de búsqueda por palabra clave',
    buscar_aria: 'Botón para iniciar la búsqueda',
    header_collections_aria: 'Ir a la sección de colecciones',
    header_favorites_aria: 'Ver recursos favoritos',

    // Textos de Footer.js
    footer_red_aprende: 'Red Aprende',
    footer_collections: 'Colecciones',
    footer_data_treatment: 'Tratamiento de datos personales',
    footer_privacy_terms: 'Privacidad y condiciones de uso',
    footer_digital_security: 'Seguridad digital',
    footer_cookies: 'Cookies',
    footer_educational_level: 'Nivel Educativo',
    footer_first_child_hood: 'Primera infancia',
    footer_preschool_basic_media: 'Preescolar, básica y media',
    footer_superior_education: 'Educación superior',
    footer_work_human_development_education: 'Educación para el trabajo y el desarrollo humano',
    footer_areas_subjects: 'Áreas y asignaturas',
    footer_science_math: 'Ciencias y matemáticas',
    footer_language_humanities_society: 'Lenguaje, humanidades y sociedad',
    footer_art_culture_expression: 'Arte, Cultura y Expresión',
    footer_physical_education: 'Educación física, recreación y deportes',
    footer_health_wellness: 'Salud y bienestar',
    footer_healthy_habits: 'Promueve hábitos saludables y bienestar integral',
    footer_external_links: 'Enlaces externos',
    footer_currideas: 'CurrIdeas',
    footer_colombia_aprende_link: 'Colombia Aprende',
    footer_mineducacion_title: 'Ministerio de Educación Nacional',
    footer_address_label: 'Dirección:',
    footer_address_value: 'Calle 43 No. 57 - 14. CAN. Bogotá, Colombia. Código Postal 111321.',
    footer_phone_conmutator_label: 'Teléfono Conmutador:',
    footer_phone_conmutator_value: '(601) 22 22800',
    footer_free_line_label: 'Línea gratuita fuera de Bogotá:',
    footer_free_line_value: '018000 - 510258',
    footer_attention_schedule_label: 'Horario de atención',
    footer_attention_schedule_value: 'Lunes a jueves de 8:00 a.m. a 5:00 p.m. y viernes de 7:00 a.m. a 4:00 p.m. Jornada continua.',
    footer_tech_support_label: 'Soporte técnico - Sistemas de información. Teléfono:',
    footer_tech_support_value: '(601) 432 1215',
    footer_national_free_line: 'Línea gratuita nacional',
    footer_anti_corruption_email_label: 'Correo Anticorrupción:',
    footer_judicial_notifications_email_label: 'Correo de notificaciones judiciales:',
    footer_channels_attention: 'Canales físicos y electrónicos para atención al público',
    footer_social_networks: 'Redes sociales',
    footer_interest_links: 'Enlaces de interés',
    footer_terms_conditions: 'Términos y condiciones',
    footer_policies: 'Políticas',
    footer_sitemap: 'Mapa del sitio',
    footer_accessibility: 'Accesibilidad',
    footer_administration: 'Administración',
    footer_platform_of: 'Una plataforma de ',
    footer_sitemap_aria: 'Navegación del mapa del sitio',
    footer_collections_aria: 'Ir a la sección de colecciones',
    footer_data_treatment_aria: 'Ver política de tratamiento de datos personales',
    footer_privacy_terms_aria: 'Ver política de privacidad y condiciones de uso',
    footer_digital_security_aria: 'Ver información de seguridad digital',
    footer_cookies_aria: 'Ver política de cookies',
    footer_first_child_hood_aria: 'Ir a recursos de primera infancia',
    footer_preschool_basic_media_aria: 'Ir a recursos de preescolar, básica y media',
    footer_superior_education_aria: 'Ir a recursos de educación superior',
    footer_work_human_development_education_aria: 'Ir a recursos de educación para el trabajo y desarrollo humano',
    footer_science_math_aria: 'Ir a recursos de ciencias y matemáticas',
    footer_language_humanities_society_aria: 'Ir a recursos de lenguaje, humanidades y sociedad',
    footer_art_culture_expression_aria: 'Ir a recursos de arte, cultura y expresión',
    footer_physical_education_aria: 'Ir a recursos de educación física, recreación y deportes',
    footer_health_wellness_aria: 'Ir a recursos de salud y bienestar',
    footer_healthy_habits_aria: 'Ir a recursos de hábitos saludables y bienestar integral',
    footer_currideas_aria: 'Abrir enlace a CurrIdeas en nueva ventana',
    footer_colombia_aprende_link_aria: 'Abrir enlace a Colombia Aprende en nueva ventana',
    footer_anti_corruption_email_aria: 'Enviar correo electrónico a soytransparente@mineducacion.gov.co',
    footer_judicial_notifications_email_aria: 'Enviar correo electrónico a notificacionesjudiciales@mineducacion.gov.co',
    footer_channels_attention_aria: 'Ver canales físicos y electrónicos para atención al público',
    footer_social_networks_aria: 'Navegación de redes sociales',
    footer_facebook_link_aria: 'Abrir perfil de Facebook del Ministerio de Educación Nacional',
    footer_instagram_link_aria: 'Abrir perfil de Instagram del Ministerio de Educación Nacional',
    footer_x_link_aria: 'Abrir perfil de X (anteriormente Twitter) del Ministerio de Educación Nacional',
    footer_youtube_link_aria: 'Abrir canal de YouTube del Ministerio de Educación Nacional',
    footer_linkedin_link_aria: 'Abrir perfil de LinkedIn del Ministerio de Educación Nacional',
    footer_interest_links_aria: 'Navegación de enlaces de interés',
    footer_terms_conditions_aria: 'Ver términos y condiciones',
    footer_policies_aria: 'Ver políticas',
    footer_sitemap_link_aria: 'Ver mapa del sitio',
    footer_accessibility_aria: 'Ir a la sección de accesibilidad',
    footer_administration_aria: 'Ir a la página de administración',
    footer_colombia_aprende_link_bottom_aria: 'Abrir enlace de la plataforma Colombia Aprende',

    // Textos de Accessibility.js
    accessibility_contrast: 'Contraste',
    accessibility_reduce_letter: 'Reducir letra',
    accessibility_increase_letter: 'Aumentar letra',

    // Textos de Landing.js
    landing_banner_title: 'Explora y enseña con RED Aprende',
    landing_banner_subtitle: 'Más de <span>25 mil recursos digitales</span> listos para <b>docentes y estudiantes</b>',
    landing_banner_explore_collections: 'Explorar colecciones ahora',
    landing_more_collections: 'Explorar todas las colecciones',
    landing_education_title: 'Encuentra lo que necesitas según tu etapa educativa',
    landing_education_primary: 'Primera infancia',
    landing_education_basic: 'Preescolar, básica y media',
    landing_education_superior: 'Educación superior',
    landing_education_work: 'Educación para el trabajo y el desarrollo humano',
    landing_areas_title: 'Explora por áreas de conocimiento',
    landing_science_math_title: 'Ciencias y Matemáticas',
    landing_science_math_description: 'Explora desde ciencias básicas hasta aplicaciones técnicas.',
    landing_view_resources: 'Ver recursos ',
    landing_language_humanities_title: 'Lenguaje, Humanidades y Sociedad',
    landing_language_humanities_description: 'Comunicación, historia, filosofía y ciudadanía en un mismo lugar',
    landing_habits_title: 'Promueve hábitos saludablesy bienestar integral.',
    landing_habits_description: 'Materiales para formación docente y fortalecimiento pedagógico.',
    landing_art_culture_title: 'Arte, Cultura y Expresión',
    landing_art_culture_description: 'Recursos para la expresión artística, la ética y la vida cultural.',
    landing_health_wellness_title: 'Salud y Bienestar',
    landing_health_wellness_description: 'Promueve hábitos saludablesy bienestar integral.',
    landing_learn_how_to_learn: 'Elige cómo quieres aprender',
    landing_joinus_title: 'Docentes de todo el país ya usan RED Aprende.',
    landing_joinus_subtitle: 'Únete y aprovecha los recursos digitales disponibles para tu aula.',
    landing_joinus_more: 'Explora recursos ahora',
    landing_banner_title_aria: 'Sección principal: Explora y enseña con RED Aprende',
    landing_banner_explore_collections_aria: 'Explorar colecciones de la sección principal',
    landing_more_collections_aria: 'Explorar todas las colecciones',
    landing_education_primary_aria: 'Fase educativa: Primera infancia',
    landing_education_basic_aria: 'Fase educativa: Preescolar, básica y media',
    landing_education_superior_aria: 'Fase educativa: Educación superior',
    landing_education_work_aria: 'Fase educativa: Educación para el trabajo y el desarrollo humano',
    landing_view_resources_science_aria: 'Ver recursos de Ciencias y Matemáticas',
    landing_view_resources_language_aria: 'Ver recursos de Lenguaje, Humanidades y Sociedad',
    landing_view_resources_habits_aria: 'Ver recursos de Hábitos saludables y bienestar integral',
    landing_view_resources_art_aria: 'Ver recursos de Arte, Cultura y Expresión',
    landing_view_resources_health_aria: 'Ver recursos de Salud y Bienestar',
    landing_resource_format_textual_aria: 'Explorar recursos de formato textual',
    landing_resource_format_graphic_aria: 'Explorar recursos de formato gráfico',
    landing_resource_format_sonorous_aria: 'Explorar recursos de formato sonoro',
    landing_resource_format_audiovisual_aria: 'Explorar recursos de formato audiovisual',
    landing_resource_format_multimedia_aria: 'Explorar recursos de formato multimedia',
    landing_resource_format_interactive_aria: 'Explorar recursos de formato interactivo',
    landing_resource_format_textual_alt: 'Icono de recursos textuales',
    landing_resource_format_graphic_alt: 'Icono de recursos gráficos',
    landing_resource_format_sonorous_alt: 'Icono de recursos sonoros',
    landing_resource_format_audiovisual_alt: 'Icono de recursos audiovisuales',
    landing_resource_format_multimedia_alt: 'Icono de recursos multimedia',
    landing_resource_format_interactive_alt: 'Icono de recursos interactivos',
    objeto_view_group_aria: 'Ver detalles del grupo {{title}}',
    objeto_view_resource_aria: 'Ver detalles del recurso {{title}}',
    objeto_image_alt: 'Imagen de previsualización para {{title}}',
    objeto_resources_count_aria: 'Número de recursos: {{count}}',
    objeto_resource_singular: 'recurso',
    objeto_resource_plural: 'recursos',
    objeto_average_rating_aria: 'Calificación promedio: {{rating}} de 5 estrellas',
    objeto_view_collection_aria: 'Ver colección',
    objeto_view_collection: 'Ver colección'
  }
};

export default es;
